import { render, staticRenderFns } from "./Filedownload.vue?vue&type=template&id=b2018aca&scoped=true&"
import script from "./Filedownload.vue?vue&type=script&lang=js&"
export * from "./Filedownload.vue?vue&type=script&lang=js&"
import style0 from "./Filedownload.vue?vue&type=style&index=0&id=b2018aca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2018aca",
  null
  
)

export default component.exports